import { useContext, useEffect, useState } from 'react';
import { AppState } from 'react-native';
import { NavigationContext } from '@react-navigation/native';

/**
 * Vrai quand l'écran est réellement sous les yeux : onglet au premier plan ET application active.
 *
 * `useIsFocused` lève hors d'un navigateur, et les écrans d'Offres sont rendus ainsi dans leurs
 * tests : on lit donc le contexte directement. Sans navigateur (ces tests seulement), le critère
 * de focus vaut vrai et seul l'état de l'application compte.
 */
export function useEcranActif(): boolean {
  const navigation = useContext(NavigationContext);
  const [focus, setFocus] = useState(() => (navigation ? navigation.isFocused() : true));
  const [appActive, setAppActive] = useState(() => AppState.currentState === 'active');

  useEffect(() => {
    if (!navigation) return;
    setFocus(navigation.isFocused());
    const enFocus = navigation.addListener('focus', () => setFocus(true));
    const enBlur = navigation.addListener('blur', () => setFocus(false));
    return () => {
      enFocus();
      enBlur();
    };
  }, [navigation]);

  useEffect(() => {
    const sub = AppState.addEventListener('change', (etat) => setAppActive(etat === 'active'));
    return () => sub.remove();
  }, []);

  return focus && appActive;
}
